import { User } from '@vis-auth/vis-user-client';
import { ReactNode } from 'react';
import type { Column } from 'react-table';

export type UserRow = {
  id: ReactNode;
  userStatus: ReactNode;
  userRole: string;
  companyName: string;
  actions: ReactNode;
};

export const userColumns: Column<UserRow>[] = [
  {
    Header: 'User ID',
    accessor: 'id',
    width: 120,
  },
  {
    Header: 'Status',
    accessor: 'userStatus',
    width: 170,
  },
  {
    Header: 'User Role',
    accessor: 'userRole',
    width: 170,
  },
  {
    Header: 'Company',
    accessor: 'companyName',
    width: 300,
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    width: 130,
    disableSortBy: true,
  },
];

export type LegacyUserRow = {
  id: string;
  userStatus: ReactNode;
  userRole: string;
  companyName: string;
  lastLoginDate: string;
  actions: ReactNode;
};

export const legacyUserColumns: Column<LegacyUserRow>[] = [
  {
    Header: 'User ID',
    accessor: 'id',
    width: 120,
  },
  {
    Header: 'Status',
    accessor: 'userStatus',
    width: 250,
  },
  {
    Header: 'User Role',
    accessor: 'userRole',
    width: 210,
  },
  {
    Header: 'Company',
    accessor: 'companyName',
    width: 300,
  },
  {
    Header: 'Last Sign-in',
    accessor: 'lastLoginDate',
    width: 180,
  },
  {
    Header: 'Link or Hide Account',
    accessor: 'actions',
    width: 250,
    disableSortBy: true,
  },
];

export const defaultFieldValue = '--';

// Link user account modal constants
export const linkUserAccountErrors = {
  alreadyMigrated: 'This account has already been migrated to sign in with Login.gov.',
  invalidCredentials: 'User ID and/or password is incorrect.',
  webServicesAccess:
    'A Web Services Access ID cannot be used to sign in to this application. Try using a different User ID.',
  wrongApp: 'You do not have access to E-Verify. Try using a different User ID.',
  general:
    'Something went wrong. Please wait a few minutes and try again. If the problem continues, contact your Administrator.',
};
export const forgotPasswordErrors = {
  general: 'We are unable to reset your password. Please wait a few minutes and try again.',
};
export type LinkModalFormValues = {
  username: string;
  password: string;
};
export type ForgotPasswordModalFormValues = {
  id: string;
};
export type UpdateUserInfo = {
  migrationToken: string;
  user: User;
};
export type UserUpdateRow = {
  userAccountInfo: string;
  previous: string;
  updated: string;
};
export const userUpdateColumns: Column<UserUpdateRow>[] = [
  {
    Header: 'User Account Info',
    accessor: 'userAccountInfo',
    isRowHeader: true,
    maxWidth: 80,
  },
  {
    Header: 'Previous',
    accessor: 'previous',
  },
  {
    Header: 'Updated',
    accessor: 'updated',
  },
];
export const userIDLength = 8;

export type UserProfileFormValues = {
  emailAddress: string;
  firstName: string;
  middleInitial?: string;
  lastName: string;
  phoneNumber: string;
  phoneExt?: string;
};

export const UNLINKED_USER_ACCOUNTS_LOCAL_STORAGE_KEY = 'eve-unlinked-user-accounts';

export const invalidAccountId = '-1';
